import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 契約者情報取得API
 */
export namespace ApiTaLi130 {
  // API Name
  export const name: string = 'ApiTaLi130'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/contractors'

    export interface Request {}

    export interface ContractorCourse {
      courseId: string
      name: string
    }

    export interface Contractor {
      localUID: string
      firstName: string
      lastName: string
      kanaName: string
      courses: ContractorCourse[]
    }

    export interface Response {
      contractors: Contractor[]
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      _params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        contractors: [
          {
            localUID: '',
            firstName: '',
            lastName: '',
            kanaName: '',
            courses: [
              {
                courseId: '',
                name: '',
              },
            ],
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
